import { NavLink } from "react-router-dom";
import { SearchBar } from "@/components/common/SearchBar";

export function TopBar() {
  return (
    <header className="sticky top-0 z-40 glass border-b border-base-600">
      <div className="flex items-center gap-4 px-4 md:px-6 h-16">
        <div className="flex items-center gap-2 md:hidden">
          <div className="w-8 h-8 rounded-lg bg-emerald/10 flex items-center justify-center text-emerald font-display font-bold text-sm">
            P
          </div>
        </div>
        <div className="hidden lg:block">
          <h1 className="font-display text-lg font-semibold tracking-tight">Pitchside</h1>
          <p className="text-[11px] text-ink-500 -mt-0.5">Every kickoff, live.</p>
        </div>

        <div className="flex-1 flex justify-center md:justify-start md:ml-4">
          <SearchBar />
        </div>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg transition-colors ${
                isActive ? "text-emerald bg-emerald/10" : "text-ink-500 hover:text-ink-100"
              }`
            }
          >
            Live
          </NavLink>
          <NavLink
            to="/schedule"
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg transition-colors ${
                isActive ? "text-emerald bg-emerald/10" : "text-ink-500 hover:text-ink-100"
              }`
            }
          >
            Schedule
          </NavLink>
          <NavLink
            to="/leagues"
            className={({ isActive }) =>
              `px-3 py-2 rounded-lg transition-colors ${
                isActive ? "text-emerald bg-emerald/10" : "text-ink-500 hover:text-ink-100"
              }`
            }
          >
            Leagues
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
